import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

export type PageContextData = {
  ENV: any;
  currentPathWithRepub: string;
  deviceType: 'DESKTOP' | 'TABLET' | 'MOBILE';
  fullPageUrl: string;
  gtmId: string;
};

export const PageContext = createContext<PageContextData | undefined>(undefined);
PageContext.displayName = 'PageContext';

export const PageProvider = ({
  ENV,
  children,
  currentPathWithRepub,
  deviceType,
  fullPageUrl,
  gtmId,
}: PropsWithChildren<PageContextData>) => {
  const value = useMemo(
    () => ({
      ENV,
      currentPathWithRepub,
      deviceType,
      fullPageUrl,
      gtmId,
    }),
    [ENV, currentPathWithRepub, deviceType, fullPageUrl, gtmId],
  );

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePageContext can only be used inside of PageProvider');
  }

  return context;
};
